/** F8 — 2FA, convite/redefinição de senha e auditoria. */
import { z } from 'zod';
import { Senha } from './auth.js';
import { Id, Paginacao } from './comum.js';

/** Resposta do login quando o usuário tem 2FA: sem sessão ainda; o código vem em /2fa/validar. */
export const Desafio2fa = z.object({ precisa2fa: z.literal(true), desafio: z.string() });
export type Desafio2fa = z.infer<typeof Desafio2fa>;

export const Codigo2fa = z.string().trim().min(6).max(12);
export const Validar2faBody = z.object({ desafio: z.string().min(10), codigo: Codigo2fa });
export const Confirmar2faBody = z.object({ codigo: Codigo2fa });
export const Desativar2faBody = z.object({ senha: z.string().min(1), codigo: Codigo2fa });
export const Iniciar2faResposta = z.object({ segredo: z.string(), url: z.string() });
export const Confirmar2faResposta = z.object({ codigosRecuperacao: z.array(z.string()) });

export const EsqueciBody = z.object({ email: z.email().max(200) });
export const RedefinirBody = z.object({ token: z.string().min(10).max(200), senha: Senha });
export const TokenInfo = z.object({ valido: z.boolean(), tipo: z.enum(['CONVITE', 'RESET']).nullable(), nome: z.string().nullable(), email: z.string().nullable() });

export const AuditoriaQuery = Paginacao.extend({
  de: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  ate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  entidade: z.string().trim().max(40).optional(),
  acao: z.string().trim().max(60).optional(),
  busca: z.string().trim().max(120).optional(),
  usuarioId: Id.optional(),
});
export type AuditoriaQuery = z.infer<typeof AuditoriaQuery>;
export const AuditoriaItem = z.object({
  id: z.string(), quando: z.string(), usuarioId: Id.nullable(), usuarioNome: z.string().nullable(), acao: z.string(), entidade: z.string(), entidadeId: z.string().nullable(),
  descricao: z.string().nullable(), antes: z.unknown().nullable(), depois: z.unknown().nullable(), ip: z.string().nullable(),
});
export const AuditoriaResposta = z.object({ itens: z.array(AuditoriaItem), total: z.number().int(), page: z.number().int(), perPage: z.number().int(), entidades: z.array(z.string()) });
export type AuditoriaResposta = z.infer<typeof AuditoriaResposta>;
